import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import "react-datetime/css/react-datetime.css";
import { connect } from "react-redux";
import moment from "moment";
import { debounce } from "lodash";
import {
	Card,
	CardActionArea,
	CardActions,
	CardContent,
	CardMedia,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	LinearProgress,
	Button as MButton,
	Paper,
	Tooltip,
	FormControlLabel,
	Box,
	Switch
} from "@material-ui/core";
import ReadMore from "../../components/Truncate/Truncate";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import styled from "styled-components";
import {
	Modal,
	Form,
	Table,
	Row,
	Col,
	Button,
	Pagination,
	Spinner,
	InputGroup,
	Toast,
	Image,
	Tabs,
	Tab,
} from "react-bootstrap";
import {
	AddCircle,
	CancelScheduleSend,
	Send,
	Edit,
	Photo,
	Schedule,
} from "@material-ui/icons";
import API from "../../network/dashboardAPI";
import Loader from "../../components/Loader/Loader";
import UploadService from "../../services/FileUploadService";
// import { Editor } from "@tinymce/tinymce-react";
// import * as Constant from "../../constants/Constant";
import EditorTool from "../../components/EditorTool";

const NotificationCenter = (props) => {
	let admin = localStorage.getItem("admin");
	let mql = window.matchMedia("all and (min-width: 769px)");

	if (!admin) window.location.href = "/";

	const [customers, setCustomers] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [customerTotal, setCustomersTotal] = useState([]);
	const [customerOffset, setCustomerOffset] = useState(0);

	const [registeredFcmUsers, setRegisteredFcmUsers] = useState({});
	const [fcmUsersPage, setFcmUsersPage] = useState(1);
	const [searchFcmUsers, setSearchFcmUsers] = useState(1);
	const [allNotifications, setAllNotifications] = useState({});
	const [draftNotifications, setDraftNotifications] = useState({});
	const [scheduleId, setScheduleId] = useState("");
	const [openDialog, setOpenDialog] = useState(false);

	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const _startDateRef = useRef("");
	const _endDateRef = useRef("");
	const _searchRef = useRef("");

	// Schedule
	const [isSchedule, setIsSchedule] = useState(false);
	const [isEmailEnable, setIsEmailEnable] = useState(false);
	const [schedule, setSchedule] = useState({ date: "", time: "" });
	const _switchCheckSchedule = useRef(false);
	const _scheduleDate = useRef("");
	const _scheduleTime = useRef("");

	// toast states
	const [toastBgColor, setToastBgColor] = useState("bg-success");
	const [showToast, setShowToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("Delete successful");

	// Filter states
	const [selectedStatus, setSelectedStatus] = useState("all");

	// Use ref
	const _textSearch = React.useRef("");

	//select customer
	const [customerIDs, setCustomerIDs] = useState([]);
	const [isSelected, setIsSelected] = useState(false);
	// "Select every customer matching the current filter/search" — the audience is
	// resolved server-side instead of shipping every id up in the request body.
	// Cleared by any manual selection change, and by changing filter/search/tab.
	const [selectAllMatching, setSelectAllMatching] = useState(false);

	// customerIDs is an array because the request body needs one, but membership
	// is tested once per visible row and twice per render for the header
	// checkbox. Array.includes is a linear scan, which made those tests
	// O(rows x selected) and locked the page up for seconds per keystroke once a
	// large audience was selected. The Set makes every test O(1).
	const selectedIdSet = useMemo(() => new Set(customerIDs), [customerIDs]);

	//notification
	const [notificationType, setNotificationType] = useState(0);
	const [generalTypeItemID, setGeneralTypeItemID] = useState("");
	const [generalTypeItemSearch, setGeneralTypeItemSearch] = useState("");
	const [notificationTitle, setNotificationTitle] = useState("");
	const [notificationBody, setNotificationBody] = useState("");
	const [notificationActionUrl, setNotificationActionUrl] = useState("");
	const [notificationIconUrl, setNotificationIconUrl] = useState("");
	const [showNotificationFormModal, setShowNotificationFormModal] =
		useState(false);
	const [isNotificationPushing, setIsNotificationPushing] = useState(false);
	const [isUploadingImage, setIsUploadingImage] = useState(false);

	const [products, setProducts] = useState([]);
	const [categories, setCategories] = useState([]);
	const [subCategories, setSubCategories] = useState([]);
	const [brands, setBrands] = useState([]);
	const [searchLoading, setSearchLoading] = useState(false);
	const [isSearched, setIsSearched] = useState(false);
	const [notificationPage, setNotificationPage] = useState(1);
	const [generalTypeItemPage, setGeneralTypeItemPage] = useState(1);
	const [categoryID, setCategoryID] = useState(null);

	// Pagination — customers are now paged on the server, so `customers` holds one
	// page rather than the entire table.
	const [pageNumber, setPageNumber] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const customerTotalPages = Math.max(1, Math.ceil((customerTotal || 0) / pageSize));

	const _notificationIconInputFile = useRef(null);
	const _switchCheckTargetCustomer = useRef(null);
	// form error
	const [formError, setFormError] = useState({
		title: "",
		body: "",
		typeItemID: "",
		scheduleDate: "",
		scheduleTime: "",
		// actionUrl: "",
		// iconUrl: "",
	});

	const listNotificationType = [
		{ name: "Select Type (default)", value: 0 },
		{ name: "Product", value: 1 },
		{ name: "Category", value: 2 },
		{ name: "Sub Category", value: 3 },
		{ name: "Brand", value: 4 },
		{ name: "New Arrival", value: 5 },
		{ name: "Promotion", value: 6 },
		{ name: "Flash Sale", value: 7 },
		{ name: "Express", value: 8 },
		{ name: "landingPage", value: 9 },
		{ name: "partnerPage", value: 10 },
	];

	// Ask the server for one page instead of the whole customer table. The
	// endpoint has accepted page/limit since the June query-optimisation pass; it
	// only fell back to "return everything" because this caller never sent them.
	// On the guest/anonymous filter that fallback was tens of thousands of rows
	// parsed into React state on every filter change.
	const getCustomerBy = async (search = "", page = pageNumber, limit = pageSize) => {
		try {
			setIsLoading(true);
			const query = selectedStatus;
			API.getCustomersNoPagination(query, { search, page, limit })
				.then((res) => res.json())
				.then((res) => {
					if (res.success) {
						setCustomersTotal(res.total);
						setCustomers(res.result);
					} else {
						alert("Sort not found");
					}
					setIsLoading(false);
				});
		} catch (e) {
			console.log("Error, can not find customer", e);
			setCustomers([]);
			setIsLoading(false);
		}
	};

	/** The search box value, for both refetching and the send-to-all audience. */
	const currentSearch = () => _textSearch.current?.value || "";

	const doSearch = useCallback(
		debounce((e) => {
			// A new search is a new audience — drop any "all matching" selection.
			setSelectAllMatching(false);
			setPageNumber(1);
			getCustomerBy(e.target.value, 1);
		}, 750),
		[_textSearch.current?.value]
	);

	const resetPagination = () => {
		setCustomerOffset(0);
		setPageNumber(1);
	};

	const handleStatusChange = (event) => {
		//  reset pagination
		resetPagination();
		// The filter defines the audience, so a change invalidates "all matching".
		setSelectAllMatching(false);

		setSelectedStatus(event.target.value);
	};

	// toast event
	const handleShowToast = (type, message) => {
		setShowToast(true);
		if (type === "SUCCESS") {
			setToastBgColor("bg-success");
		} else if (type === "ERROR") {
			setToastBgColor("bg-danger");
		} else if (type === "WARNING") {
			setToastBgColor("bg-warning");
		}
		setToastMessage(message);
	};

	// Select Customer
	//
	// All membership tests go through `selectedIdSet` (O(1)) rather than
	// Array.includes (O(selected)). With a large audience selected the old code
	// ran customers.every(x => customerIDs.includes(...)) on every render, which
	// is O(rows x selected) and cannot short-circuit when everything is
	// selected — that is what made each keystroke take seconds.
	const bulkSelection = (value) => {
		// A manual tick means the audience is no longer "everything matching".
		setSelectAllMatching(false);
		if (selectedIdSet.has(value)) {
			const next = customerIDs.filter((id) => id !== value);
			setCustomerIDs(next);
			if (!next.length) setIsSelected(false);
		} else {
			setCustomerIDs([...customerIDs, value]);
			setIsSelected(true);
		}
	};

	// Derived once per [customers, selectedIdSet] change instead of twice per
	// render. `customers` is one page now, so this is O(pageSize).
	//
	// This also replaces the isCustomerAllSeleted state that renderSelectAllCheckBox
	// used to set from inside the render pass. That setState-during-render forced an
	// extra render on every keystroke (React warns "Cannot update a component while
	// rendering a different component"), doubling the cost above. Nothing ever read
	// the flag, so it is gone rather than moved into an effect.
	const pageSelection = useMemo(() => {
		if (!customers.length) return { all: false, some: false };
		let selected = 0;
		for (const customer of customers) {
			if (selectedIdSet.has(customer.cust_id)) selected++;
		}
		return { all: selected === customers.length, some: selected > 0 };
	}, [customers, selectedIdSet]);

	const bulkSelectionAll = () => {
		if (!customers.length) return;
		setSelectAllMatching(false);

		if (pageSelection.some) {
			// Deselect this page, keep selections made on other pages.
			const pageIds = new Set(customers.map((x) => x.cust_id));
			const next = customerIDs.filter((id) => !pageIds.has(id));
			setCustomerIDs(next);
			if (!next.length) setIsSelected(false);
		} else {
			const next = new Set(customerIDs);
			for (const customer of customers) next.add(customer.cust_id);
			setCustomerIDs([...next]);
			setIsSelected(true);
		}
	};

	/**
	 * Select every customer matching the current filter + search, without pulling
	 * their ids into the browser. The audience is resolved server-side at send
	 * time from { send_to_all, filter, search }.
	 */
	const selectAllMatchingCustomers = () => {
		setSelectAllMatching(true);
		setIsSelected(true);
	};

	const clearSelection = () => {
		setSelectAllMatching(false);
		setCustomerIDs([]);
		setIsSelected(false);
	};

	/** True when there is an audience to send to, by either selection mode. */
	const hasAudience = selectAllMatching || customerIDs.length > 0;

	const renderSelectAllCheckBox = () => (
		<Checkbox
			checked={selectAllMatching || pageSelection.all}
			indeterminate={!selectAllMatching && !pageSelection.all && pageSelection.some}
			onChange={() => bulkSelectionAll()}
			color="primary"
			inputProps={{ "aria-label": "select all customers on this page" }}
		/>
	);

	//Notification Handle
	const handleChangeNotificationType = (e) => {
		setNotificationType(parseInt(e.target.value));
		setGeneralTypeItemID("");
		setGeneralTypeItemSearch("");
		setGeneralTypeItemPage(1);
		setIsSearched(false);
		if (formError.typeItemID) {
			setFormError({
				...formError,
				typeItemID: "",
			});
		}
	};

	const doSearchGeneralTypeItem = (type, value) => {
		switch (type) {
			case "product":
				{
					let body = {
						limit: 10,
						page: generalTypeItemPage,
						search: value,
						filter: {},
					};
					API.getProduct(body)
						.then((response) => response.json())
						.then((response) => {
							if (response.success) {
								setProducts(response.data);
							}
							setSearchLoading(false);
						});
				}
				break;
			case "category":
				{
					let body = {
						store_id: 1,
						get_type: 1,
						limit: 10,
						page: generalTypeItemPage,
						search: value,
					};
					API.searchCategory(body)
						.then((response) => response.json())
						.then((response) => {
							if (response.success) {
								setCategories(response.data);
							}
							setSearchLoading(false);
						});
				}
				break;
			case "sub_category":
				{
					let body = {
						store_id: 1,
						get_type: 1,
						limit: 10,
						page: generalTypeItemPage,
						search: value,
					};
					API.searchSubCategory(body)
						.then((response) => response.json())
						.then((response) => {
							if (response.success) {
								setSubCategories(response.data);
							}
							setSearchLoading(false);
						});
				}
				break;
			default:
				// brand
				{
					let body = {
						limit: 10,
						page: generalTypeItemPage,
						search: value,
					};
					API.searchBrands(body)
						.then((response) => response.json())
						.then((response) => {
							if (response.success) {
								setBrands(response.data);
							}
							setSearchLoading(false);
						});
				}
				break;
		}
	};

	const handleSearchGeneralTypeItem = useCallback(
		debounce((e) => {
			const { value } = e.target;
			if (!value) {
				setProducts([]);
				setIsSearched(false);
				return;
			}
			setIsSearched(true);
			setSearchLoading(true);
			setGeneralTypeItemID(parseInt(value));
			setGeneralTypeItemPage(1);
			let type = "";
			switch (notificationType) {
				case 1:
					type = "product";
					break;
				case 2:
					type = "category";
					break;
				case 3:
					type = "sub_category";
					break;
				default:
					type = "brand";
					break;
			}
			doSearchGeneralTypeItem(type, value);

			if (formError.typeItemID) {
				setFormError({
					...formError,
					typeItemID: "",
				});
			}
		}, 750),
		[generalTypeItemID, notificationType]
	);

	const handleSetGeneralTypeItemID = (itemId) => {
		setGeneralTypeItemSearch(itemId);
		setGeneralTypeItemID(parseInt(itemId));
		setIsSearched(false);
		if (formError.typeItemID) {
			setFormError({
				...formError,
				typeItemID: "",
			});
		}
	};
	const handleChangeNotificationTitle = (value) => {
		console.log("value", value);
		// e.preventDefault();
		const filteredContent = value.replace(/&amp;/g, '&');
		setNotificationTitle(filteredContent);
		if (formError.title) {
			setFormError({
				...formError,
				title: "",
			});
		}
	};
	const handleChangeNotificationBody = (value) => {
		// e.preventDefault();
		const filteredContent = value.replace(/&amp;/g, '&');
		setNotificationBody(filteredContent);
		if (formError.body) {
			setFormError({
				...formError,
				body: "",
			});
		}
	};
	const handleChangeNotificationActionUrl = (e) => {
		e.preventDefault();
		setNotificationActionUrl(e.target.value);
	};

	// Submit Send Notification
	const handleSendNotification = (e) => {
		e.preventDefault();
		if (!hasAudience) {
			return alert("Please select customer(s) before sending");
		}
		if (!validateNotification()) return;
		pushNotification();
	};

	const handleOpenNotificationFormModal = () => {
		if (!hasAudience) {
			return handleShowToast("WARNING", "Customers have not been selected");
		}
		setShowNotificationFormModal(true);
		// if (isSelected) {
		//   setShowNotificationFormModal(true)
		// } else {
		//   handleShowToast('WARNING', 'Customers have not seleted');
		// }
	};
	const handleCloseNotificationFormModal = () => {
		if (isNotificationPushing) return;
		setShowNotificationFormModal(false);
		resetNotificationForm();
	};
	const handleNotificationIconChange = async (action) => {
		try {
			setIsUploadingImage(true);
			let formData = null;

			if (_notificationIconInputFile.current !== null && action === "home") {
				formData = new FormData();
				formData.append("image", _notificationIconInputFile.current.files[0]);

				await UploadService.uploadImageFromDashboard(formData).then((response) => {
					if (response.data.success && response.data.data.length) {
						handleShowToast("SUCCESS", "Upload Icon success");
						setNotificationIconUrl(response.data.data[0].url);
					}
					setIsUploadingImage(false);
				});
			}
		} catch (e) {
			console.log("Debug: ", e);
			handleShowToast("ERROR", "Upload Icon failed");
			setIsUploadingImage(false);
		}
	};
	const validateNotification = () => {
		let tmpFormError = {
			title: "",
			body: "",
			typeItemID: "",
			scheduleDate: "",
			scheduleTime: "",
			// actionUrl: "",
			// iconUrl: "",
		};

		if (notificationTitle === "") tmpFormError.title = " * is required";
		if (notificationBody === "") tmpFormError.body = " * is required";
		if ([1, 2, 3, 4].includes(notificationType) && !generalTypeItemID) {
			tmpFormError.typeItemID = " * is required";
		}
		if (isSchedule) {
			if (!schedule.date) {
				tmpFormError.scheduleDate = " * is required";
			}
			if (!schedule.time) {
				tmpFormError.scheduleTime = " * is required";
			}
		}
		// if (notificationIconUrl === "") tmpFormError.iconUrl = " * is required";
		// if (notificationActionUrl === "") tmpFormError.actionUrl = " * is required";

		if (Object.values(tmpFormError).every((el) => el === "")) {
			return true;
		} else {
			setFormError({
				title: tmpFormError.title,
				body: tmpFormError.body,
				typeItemID: tmpFormError.typeItemID,
				scheduleDate: tmpFormError.scheduleDate,
				scheduleTime: tmpFormError.scheduleTime,
				// actionUrl: tmpFormError.actionUrl,
				// iconUrl: tmpFormError.iconUrl,
			});
			return false;
		}
	};

	const resetNotificationForm = () => {
		setIsSchedule(false);
		setIsEmailEnable(false);
		setSchedule({ date: "", time: "" });
		setNotificationType(0);
		setGeneralTypeItemPage(1);
		setGeneralTypeItemID("");
		setGeneralTypeItemSearch("");
		setNotificationTitle("");
		setNotificationBody("");
		setNotificationActionUrl("");
		setNotificationIconUrl("");
		setIsSearched(false);
		setProducts([]);
		setCategories([]);
		setSubCategories([]);
		setBrands([]);
		setFormError({
			title: "",
			body: "",
			typeItemID: "",
			scheduleDate: "",
			scheduleTime: "",
			// actionUrl: "",
			// iconUrl: "",
		});
	};

	const getNotificationType = (notificationType) => {
		switch (notificationType) {
		  case 0:
			return "campaign";
		  case 9:
			return "landingPage";
		  case 10:
			return "partnerPage";
		  default:
			return "general";
		}
	  }
	  

	const pushNotification = () => {
		setIsNotificationPushing(true);
		let body = {
			type: getNotificationType(notificationType),
			// Two audience modes. Explicit ticks still travel as an id list. "All
			// matching" sends the filter instead, so a campaign to every guest user
			// is a small request the server expands, not a multi-megabyte array of
			// ids the browser had to download first.
			...(selectAllMatching
				? {
						send_to_all: 1,
						audience_filter: selectedStatus,
						audience_search: currentSearch(),
						cust_id: [],
				  }
				: { cust_id: customerIDs }),
			title: notificationTitle,
			body: notificationBody,
			icon: notificationIconUrl,
			action: notificationActionUrl,
			status: isSchedule ? 1 : 0,
			is_enable_email: !!isEmailEnable ? 1 : 0,
			schedule:
				isSchedule && schedule.date && schedule.time
					? moment(schedule.date).format("YYYY-MM-DD") +
					  " " +
					  moment(schedule.time, "hh:mm A").format("HH:mm:ss")
					: null,
		};

		if (notificationType !== 0) {
			body = {
				...body,
				data: {
					type: notificationType,
				},
			};
			// PRODUCT, CATEGORY, SUB_CATEGORY, BRAND
			if ([1, 2, 3, 4].includes(notificationType)) {
				body = {
					...body,
					target: _switchCheckTargetCustomer.current?.checked ? 1 : 0,
					data: {
						...body?.data,
						type_item_id: generalTypeItemID,
					},
				};

				// CATEGORY, SUB_CATEGORY
				if ([2, 3].includes(notificationType)) {
					body = {
						...body,
						data: {
							...body?.data,
							shopId: 1,
						},
					};
					// SUB_CATEGORY
					if (notificationType === 3) {
						body = {
							...body,
							data: {
								...body?.data,
								catId: categoryID,
							},
						};
					}
				}
			}
		}

		API.pushNotification(body)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					handleShowToast("SUCCESS", "Push notification successful");
          setCategoryID([])
				} else {
					handleShowToast("ERROR", "Push notification failed");
				}
				setIsNotificationPushing(false);
				handleCloseNotificationFormModal();
			});
	};

	const paginNext = (type) => {
		switch (type) {
			case "customers":
				// Paging now refetches (see the [pageNumber, selectedStatus] effect)
				// instead of slicing a fully-loaded table.
				if (pageNumber < customerTotalPages) setPageNumber(pageNumber + 1);
				break;
			case "notifications":
				if (
					allNotifications?.totalPages > 1 &&
					notificationPage < allNotifications?.totalPages
				) {
					setNotificationPage(notificationPage + 1);
				}
				break;
			case "fcmUsers":
				if (
					registeredFcmUsers?.totalPages > 1 &&
					fcmUsersPage < registeredFcmUsers?.totalPages
				) {
					setFcmUsersPage(fcmUsersPage + 1);
				}
				break;
			default:
				setGeneralTypeItemPage(generalTypeItemPage + 1);
				break;
		}
	};
	const paginPrev = (type) => {
		switch (type) {
			case "customers":
				if (pageNumber > 1) setPageNumber(pageNumber - 1);
				break;
			case "notifications":
				if (allNotifications?.totalPages > 1 && notificationPage > 1) {
					setNotificationPage(notificationPage - 1);
				}
				break;
			case "fcmUsers":
				if (registeredFcmUsers?.totalPages > 1 && fcmUsersPage > 1) {
					setFcmUsersPage(fcmUsersPage - 1);
				}
				break;
			default:
				setGeneralTypeItemPage(generalTypeItemPage - 1);
				break;
		}
	};

	const getAllNotifications = (body) => {
		setIsLoading(true);
		API.getAllNotifications(body)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setAllNotifications(data.data);
				}
				setIsLoading(false);
			})
			.catch((err) => {
				alert(err.message);
				setIsLoading(false);
			});
	};

	const getScheduleNotifications = () => {
		setIsLoading(true);
		API.getScheduleNotifications()
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setDraftNotifications(data.data);
				}
				setIsLoading(false);
			})
			.catch((err) => {
				alert(err.message);
				setIsLoading(false);
			});
	};

	const handleToggleEditSchedulePost = (item) => {
		setOpenDialog((prev) => !prev);
		if (item) {
			setScheduleId(item?.id);
			let data = JSON.parse(item?.data);
			setSchedule({
				date: moment(item?.schedule).format("YYYY-MM-DD"),
				time: moment(item?.schedule).format("HH:mm A"),
			});
			setNotificationType(data?.generalData?.type);
			setIsEmailEnable(item?.is_send_to_email == 1 ? true : false);
			setNotificationTitle(data?.title);
			setNotificationBody(data?.body);
			setNotificationActionUrl(data?.action);
			setNotificationIconUrl(data?.icon);
		} else {
			resetNotificationForm();
		}
	};

	const handleUpdateScheduleNotification = () => {
		if (!validateNotification()) return;
		let body = {
			type: getNotificationType(notificationType),
			title: notificationTitle,
			body: notificationBody,
			icon: notificationIconUrl,
			action: notificationActionUrl,
			status: 1,
			is_enable_email: !!isEmailEnable ? 1 : 0,
			schedule:
				schedule.date && schedule.time
					? moment(schedule.date).format("YYYY-MM-DD") +
					  " " +
					  moment(schedule.time, "hh:mm A").format("HH:mm:ss")
					: null,
		};

		if (notificationType !== 0) {
			body = {
				...body,
				data: {
					type: notificationType,
				},
			};
			// PRODUCT, CATEGORY, SUB_CATEGORY, BRAND
			if ([1, 2, 3, 4].includes(notificationType)) {
				body = {
					...body,
					target: _switchCheckTargetCustomer.current?.checked ? 1 : 0,
					data: {
						...body?.data,
						type_item_id: generalTypeItemID,
					},
				};

				// CATEGORY, SUB_CATEGORY
				if ([2, 3].includes(notificationType)) {
					body = {
						...body,
						data: {
							...body?.data,
							shopId: 1,
						},
					};
					// SUB_CATEGORY
					if (notificationType === 3) {
						body = {
							...body,
							data: {
								...body?.data,
								catId: categoryID,
							},
						};
					}
				}
			}
		}

		setIsNotificationPushing(true);
		API.updateScheduleNotification(scheduleId, body)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					handleShowToast("SUCCESS", "Push notification successful");
					getScheduleNotifications();
					handleToggleEditSchedulePost(null);
					handleCloseNotificationFormModal();
				} else {
					handleShowToast("ERROR", data.message);
				}
				setIsNotificationPushing(false);
			})
			.catch((err) => {
				handleShowToast("ERROR", err.message);
			});
	};

	const handleCancelDraftNotification = (id) => {
		if (!window.confirm("Do you wish to delete this notification?")) return;
		API.cancelScheduleNotification(id)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					getScheduleNotifications();
					handleShowToast("SUCCESS", "Operation successful.");
				} else {
					handleShowToast("ERROR", data.message);
				}
				setIsLoading(false);
			})
			.catch((err) => {
				handleShowToast("ERROR", err.message);
				setIsLoading(false);
			});
	};

	const handleToSendNotification = (id) => {
		if (!window.confirm("Do you wish to send this notification?")) return;
		API.toSendNotification(id)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					getScheduleNotifications();
					handleShowToast("SUCCESS", "Operation successful.");
				} else {
					handleShowToast("ERROR", data.message);
				}
				setIsLoading(false);
			})
			.catch((err) => {
				handleShowToast("ERROR", err.message);
				setIsLoading(false);
			});
	};

	const handleEnableSchedule = (check) => {
		if (check) {
			setIsSchedule(true);
		} else {
			setIsSchedule(false);

			if (_scheduleDate.current) {
				_scheduleDate.current.state.inputValue = "";
			}
			if (_scheduleTime.current) {
				_scheduleTime.current.state.inputValue = "";
			}
			setSchedule({ date: "", time: "" });

			setFormError({
				...formError,
				scheduleDate: "",
				scheduleTime: "",
			});
		}
	};

	const handleEnableEmail = (check) => {
		setIsEmailEnable(check)
	}
	const handleChangeSchedule = (type, event) => {
		if (type === "date") {
			let tmpDate = moment(event).format("YYYY-MM-DD");
			setSchedule({ ...schedule, date: tmpDate });
			setFormError({
				...formError,
				scheduleDate: "",
			});
		} else {
			let tmpTime = moment(event).format("hh:mm A");
			setSchedule({ ...schedule, time: tmpTime });
			setFormError({
				...formError,
				scheduleTime: "",
			});
		}
	};

	const getRegisteredFcmUsers = (body) => {
		setIsLoading(true);
		API.getRegisteredFcmUsers(body)
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					setRegisteredFcmUsers(data.data);
				}
				setIsLoading(false);
			})
			.catch((err) => {
				alert(err.message);
			});
	};

	// handle sort date
	const handleSortNotificationDate = (type, event) => {
		let tmpDate = moment(event).format("YYYY-MM-DD");
		const body = {
			page: 1,
			limit: 20,
			order: [["id", "desc"]],
			start_date: startDate,
			end_date: endDate,
		};
		setNotificationPage(1);
		switch (type) {
			case "start": {
				setStartDate(tmpDate);
				getAllNotifications({ ...body, start_date: tmpDate });
				break;
			}
			case "end": {
				setEndDate(tmpDate);
				getAllNotifications({ ...body, end_date: tmpDate });
				break;
			}
			default: {
				break;
			}
		}
	};

	const handleResetNotificationDate = () => {
		if (_startDateRef && _startDateRef.current) {
			_startDateRef.current.state.inputValue = "";
			setStartDate("");
		}
		if (_endDateRef && _endDateRef.current) {
			_endDateRef.current.state.inputValue = "";
			setEndDate("");
		}

		setNotificationPage(1);
		getAllNotifications({ page: 1, limit: 20 });
	};

	const handleSearchRegisteredFcmUsers = useCallback(
		debounce((e) => {
			setSearchFcmUsers(e?.target?.value);
		}, 500),
		[searchFcmUsers, setSearchFcmUsers]
	);

	const handleSwitchTab = (tab) => {
		if (tab === "historic") {
			// getAllNotifications({});
			handleResetNotificationDate();
		} else if (tab === "firebase-users") {
			setFcmUsersPage(1);
			setSearchFcmUsers("");
			_searchRef.current.value = "";
			getRegisteredFcmUsers({});
		} else if (tab === "customers") {
			_textSearch.current.value = "";
			setSelectAllMatching(false);
			setPageNumber(1);
			setSelectedStatus("all");
			getCustomerBy("", 1);
		} else if (tab === "schedule") {
			getScheduleNotifications();
		}
	};

	// Pagination
	let pageItems = [
		<Pagination.Item
			key={0}
			disabled={pageNumber === 1}
			onClick={() => paginPrev("customers")}
		>
			Prev
		</Pagination.Item>,
		<Form.Group key={1} controlId="formGridPagination">
			<InputGroup>
				<InputGroup.Prepend>
					<InputGroup.Text>{`${pageNumber} / ${customerTotalPages}`}</InputGroup.Text>
				</InputGroup.Prepend>
			</InputGroup>
		</Form.Group>,
		<Pagination.Item
			key={2}
			disabled={pageNumber >= customerTotalPages}
			onClick={() => paginNext("customers")}
		>
			Next
		</Pagination.Item>,
	];
	let notificationPageButtons = [
		<Pagination.Item
			key={0}
			disabled={notificationPage === 1}
			onClick={() => paginPrev("notifications")}
		>
			Prev
		</Pagination.Item>,
		<Form.Group className="m-0" key={2}>
			<InputGroup>
				<InputGroup.Prepend>
					<InputGroup.Text>
						Page: {notificationPage} / {allNotifications?.totalPages}
					</InputGroup.Text>
				</InputGroup.Prepend>
			</InputGroup>
		</Form.Group>,
		<Pagination.Item
			key={3}
			disabled={notificationPage === allNotifications?.totalPages}
			onClick={() => paginNext("notifications")}
		>
			Next
		</Pagination.Item>,
	];
	let registeredFcmUsersPageButtons = [
		<Pagination.Item
			key={0}
			disabled={fcmUsersPage === 1}
			onClick={() => paginPrev("fcmUsers")}
		>
			Prev
		</Pagination.Item>,
		<Form.Group key={2} className="m-0">
			<InputGroup>
				<InputGroup.Prepend>
					<InputGroup.Text>
						Page: {fcmUsersPage} / {registeredFcmUsers?.totalPages}
					</InputGroup.Text>
				</InputGroup.Prepend>
			</InputGroup>
		</Form.Group>,
		<Pagination.Item
			key={3}
			disabled={fcmUsersPage === registeredFcmUsers?.totalPages}
			onClick={() => paginNext("fcmUsers")}
		>
			Next
		</Pagination.Item>,
	];
	let generalTypePagination = [
		<Pagination.Item
			key={0}
			disabled={generalTypeItemPage === 1}
			onClick={() => paginPrev("general_type_item")}
		>
			Prev
		</Pagination.Item>,
		<Form.Group key={1}>
			<InputGroup>
				<InputGroup.Prepend>
					<InputGroup.Text>
						Page: {generalTypeItemPage} /{" "}
						{notificationType === 1
							? products?.total_page
							: notificationType === 2
							? categories?.total_page
							: notificationType === 3
							? subCategories?.total_page
							: brands?.total_page}
					</InputGroup.Text>
				</InputGroup.Prepend>
			</InputGroup>
		</Form.Group>,
		<Pagination.Item
			key={2}
			disabled={
				notificationType === 1
					? generalTypeItemPage === products?.total_page ||
					  products?.total_page === 0
					: notificationType === 2
					? generalTypeItemPage === categories?.total_page ||
					  categories?.total_page === 0
					: notificationType === 3
					? generalTypeItemPage === subCategories?.total_page ||
					  subCategories?.total_page === 0
					: notificationType === 4
					? generalTypeItemPage === brands?.total_page || brands?.total_page === 0
					: false
			}
			onClick={() => paginNext("general_type_item")}
		>
			Next
		</Pagination.Item>,
	];
	const paginationBasic = (
		<div className="d-flex justify-content-end">
			<Pagination>{pageItems}</Pagination>
		</div>
	);

	const generalTypeSearchContent = () => {
		switch (notificationType) {
			case 1:
				return products?.list?.length ? (
					products?.list?.map((product) => {
						return (
							<tr key={product.item_id}>
								<td>{product.item_id}</td>
								<td>{product.name}</td>
								<td>{product.product_code}</td>
								<td>
									{!product.store_items_price_types[0].is_available ? (
										<small className="d-block p-1 text-center text-white bg-danger rounded rounded-1">
											Unavailable
										</small>
									) : product.store_items_price_types[0].available_quantity === 0 ? (
										<small className="d-block p-1 text-center text-white bg-danger rounded rounded-1">
											Out of Stock
										</small>
									) : (
										<small className="d-block p-1 text-center text-white bg-success rounded rounded-1">
											Available
										</small>
									)}
								</td>
								<td>
									<Button
										size="sm"
										className="w-100"
										disabled={!product.store_items_price_types[0].is_available}
										onClick={() => handleSetGeneralTypeItemID(product.item_id)}
									>
										<AddCircle />
									</Button>
								</td>
							</tr>
						);
					})
				) : searchLoading ? (
					<tr>
						<td colSpan={5}>
							<Spinner animation="border" size="sm" className="d-block mx-auto" />
						</td>
					</tr>
				) : (
					<tr>
						<td colSpan={5}>
							<p className="text-center">Product not found...</p>
						</td>
					</tr>
				);
			case 2:
				return categories?.list?.length ? (
					categories?.list?.map((category) => {
						return (
							<tr key={category.cat_id}>
								<td>{category.cat_id}</td>
								<td>{category.list_categories[0].name}</td>
								<td>
									<Button
										size="sm"
										className="w-100"
										onClick={() => handleSetGeneralTypeItemID(category.cat_id)}
									>
										<AddCircle />
									</Button>
								</td>
							</tr>
						);
					})
				) : searchLoading ? (
					<tr>
						<td colSpan={3}>
							<Spinner animation="border" size="sm" className="d-block mx-auto" />
						</td>
					</tr>
				) : (
					<tr>
						<td colSpan={3}>
							<p className="text-center">Category not found...</p>
						</td>
					</tr>
				);
			case 3:
				return subCategories?.list?.length ? (
					subCategories?.list?.map((subCategory) => {
						return (
							<tr key={subCategory.id}>
								<td>{subCategory.sub_cat_id}</td>
								<td>{subCategory.list_sub_categories[0].name}</td>
								<td>
									<Button
										size="sm"
										className="w-100"
										onClick={() => {
											setCategoryID(subCategory.cat_id);
											handleSetGeneralTypeItemID(subCategory.sub_cat_id);
										}}
									>
										<AddCircle />
									</Button>
								</td>
							</tr>
						);
					})
				) : searchLoading ? (
					<tr>
						<td colSpan={3}>
							<Spinner animation="border" size="sm" className="d-block mx-auto" />
						</td>
					</tr>
				) : (
					<tr>
						<td colSpan={3}>
							<p className="text-center">SubCategory not found...</p>
						</td>
					</tr>
				);
			default:
				return brands?.list?.length ? (
					brands?.list?.map((brand) => {
						return (
							<tr key={brand.brand_id}>
								<td>{brand.brand_id}</td>
								<td>{brand.name}</td>
								<td>
									<small
										className={`d-block p-1 text-center text-white rounded rounded-1 ${
											brand.is_available ? "bg-success" : "bg-danger"
										}`}
									>
										{brand.is_available ? "Available" : "Unavailable"}
									</small>
								</td>
								<td>
									<Button
										size="sm"
										className="w-100"
										onClick={() => handleSetGeneralTypeItemID(brand.brand_id)}
									>
										<AddCircle />
									</Button>
								</td>
							</tr>
						);
					})
				) : searchLoading ? (
					<tr>
						<td colSpan={3}>
							<Spinner animation="border" size="sm" className="d-block mx-auto" />
						</td>
					</tr>
				) : (
					<tr>
						<td colSpan={3}>
							<p className="text-center">Brand not found...</p>
						</td>
					</tr>
				);
		}
	};

	// Refetch on filter or page change. Paging is server-side now, so Prev/Next
	// asks for the next 20 rows instead of slicing a table already in memory.
	useEffect(() => {
		getCustomerBy(currentSearch(), pageNumber);
	}, [selectedStatus, pageNumber]);

	useEffect(() => {
		const body = {
			page: notificationPage,
			limit: 20,
			order: [["id", "desc"]],
			start_date: _startDateRef?.current?.state?.inputValue,
			end_date: _endDateRef?.current?.state?.inputValue,
		};

		getAllNotifications(body);
	}, [notificationPage]);

	useEffect(() => {
		const body = {
			page: fcmUsersPage,
			limit: 10,
			search: searchFcmUsers,
		};
		getRegisteredFcmUsers(body);
	}, [fcmUsersPage, searchFcmUsers]);

	useEffect(() => {
		if (!setIsSearched) return;
		let type = "";
		switch (notificationType) {
			case 1:
				type = "product";
				break;
			case 2:
				type = "category";
				break;
			case 3:
				type = "sub_category";
				break;
			default:
				type = "brand";
				break;
		}
		doSearchGeneralTypeItem(type, generalTypeItemSearch);
	}, [generalTypeItemPage]);

	return (
		<HelpPageWrapper>
			<h4 className="mb-2">Notification Center</h4>
			<Tabs defaultActiveKey={`customers`} onSelect={handleSwitchTab}>
				<Tab eventKey={`customers`} title={`Customers`}>
					<CardContainer>
						<div className="d-flex justify-content-between mb-3">
							<NotificationFormModalTrigger onClick={handleOpenNotificationFormModal}>
								Notification Form
							</NotificationFormModalTrigger>
						</div>
						<Row>
							<Col sm={12}>
								<Row className="mb-3">
									<Col sm={9}>
										<Form.Control
											style={{ width: "25rem" }}
											size="md"
											type="search"
											ref={_textSearch}
											placeholder="Search customers"
											onChange={(e) => doSearch(e)}
										/>
									</Col>

									<Col sm={3} md={3} className="d-flex justify-content-end">
										<Form.Label style={labelStyle}>Filter: </Form.Label>&nbsp;&nbsp;
										<Form.Control
											as="select"
											onChange={handleStatusChange}
											value={selectedStatus}
										>
											<option value={"all"}>All customer</option>
											<option value={"noExpress"}>Normal customer</option>
											<option value={"express"}>Express customer</option>
											<option value={"guestUser"}>Guest customer</option>
										</Form.Control>
									</Col>
								</Row>

								{/* Audience summary. "Select all N matching" avoids materialising
								    every id in the browser — the server expands the filter at
								    send time. */}
								{(pageSelection.some || selectAllMatching) && (
									<div
										className="d-flex align-items-center justify-content-between p-2 mb-2 rounded"
										style={{ background: "#f1f5f9" }}
									>
										<span>
											{selectAllMatching ? (
												<strong>
													All {customerTotal} matching customers are selected.
												</strong>
											) : (
												<>
													<strong>{customerIDs.length}</strong> customer
													{customerIDs.length === 1 ? "" : "s"} selected.
												</>
											)}
										</span>
										<span>
											{!selectAllMatching && customerTotal > customers.length && (
												<Button
													variant="link"
													size="sm"
													onClick={selectAllMatchingCustomers}
												>
													Select all {customerTotal} matching
												</Button>
											)}
											<Button variant="link" size="sm" onClick={clearSelection}>
												Clear selection
											</Button>
										</span>
									</div>
								)}

								<TableBodyWidth
									className="table-responsive"
									style={{ overflowY: "hidden" }}
								>
									<Table striped bordered hover>
										<thead>
											<tr>
												<th>{renderSelectAllCheckBox()}</th>
												<th
													className="sortable"
													// onClick={() => sortToggle("name")}
												>
													Username
													{/* <UnfoldMore /> */}
												</th>
												<th>First Name</th>
												<th>Last Name</th>
												<th>Email</th>
												<th>Phone</th>
												<th>Address</th>
												<th
													className="sortable"
													// onClick={() => sortToggle("createdAt")}
												>
													Created date
													{/* <UnfoldMore /> */}
												</th>
												{/* <th style={{ minWidth: "20vh" }} className="text-center">
                      Wallet
                    </th>
                    <th style={{ minWidth: "15vh" }} className="text-center">
                      Actions
                    </th> */}
											</tr>
										</thead>

										<tbody>
											{!isLoading ? (
												// `customers` is already one server-side page — no slicing.
												customers
													.map((item, index) => (
														<tr key={item.cust_id ?? index}>
															<td>
																<Checkbox
																	checked={
																		selectAllMatching || selectedIdSet.has(item.cust_id)
																	}
																	key={item.cust_id}
																	onChange={() => bulkSelection(item.cust_id)}
																	color="primary"
																	inputProps={{ "aria-label": "secondary checkbox" }}
																/>
															</td>
															<td>{item.name && item.name !== " " ? item.name : "N/A"}</td>
															<td>{item.first_name || "N/A"}</td>
															<td>{item.last_name || "N/A"}</td>
															<td>{item.email || "N/A"}</td>
															<td>{item.phone || "N/A"}</td>
															<td>
																{(item.list_customer_addresses || []).length
																	? item.list_customer_addresses.map((row, subIndex) => (
																			<p key={subIndex}>&bull;&nbsp;{row.area_details}</p>
																	  ))
																	: "No data"}
															</td>
															<td>{moment(item.createdAt).format("DD/MMM/YY")}</td>
														</tr>
													))
											) : (
												<tr>
													<td colSpan={12} className="text-center">
														<Spinner animation="grow" />
													</td>
												</tr>
											)}
										</tbody>
									</Table>
								</TableBodyWidth>

								<Modal
									show={showNotificationFormModal}
									aria-labelledby="contained-modal-title-vcenter"
									size="lg"
									onHide={handleCloseNotificationFormModal}
								>
									<Modal.Header closeButton>
										<Modal.Title>Send Notification</Modal.Title>
									</Modal.Header>
									<Modal.Body>
										<Form>
											<Box display="flex" flexDirection="column" gap={1}>
													<span>
														<FormControlLabel
															control={
																<Switch
																	id="switchSendByEmail"
																	checked={isEmailEnable}
																	onChange={(e) => handleEnableEmail(e.target.checked)}
																	disabled={isNotificationPushing}
																	color="primary"
																/>
															}
															label="Send by email too"
														/>
													</span>
												<span>
													<FormControlLabel
														control={
															<Switch
																id="switchSchedule"
																onChange={(e) => handleEnableSchedule(e.target.checked)}
																disabled={isNotificationPushing}
																color="primary"
															/>
														}
														label="Schedule"
													/>
												</span>
											</Box>
											<Form.Group style={{ display: "flex", gap: 10 }}>
												<div className="w-100">
													{formError.scheduleDate !== "" && (
														<FormError>Schedule Time{formError.scheduleDate}</FormError>
													)}
													<DateTime
														dateFormat="YYYY-MM-DD"
														timeFormat={false}
														closeOnSelect={true}
														inputProps={{
															placeholder: "Choose Date",
															disabled: !isSchedule,
														}}
														ref={_scheduleDate}
														value={schedule.date}
														isValidDate={(event) => {
															return moment(moment(event).format("YYYY-MM-DD")).isSameOrAfter(
																moment().format("YYYY-MM-DD")
															);
														}}
														onChange={(e) => handleChangeSchedule("date", e)}
														className="w-100"
													/>
												</div>
												<div className="w-100">
													{formError.scheduleTime !== "" && (
														<FormError>Schedule Time{formError.scheduleTime}</FormError>
													)}
													<DateTime
														dateFormat={false}
														timeFormat="hh:mm A"
														closeOnSelect={true}
														inputProps={{
															placeholder: "Choose Time",
															disabled: !isSchedule || !schedule.date,
														}}
														ref={_scheduleTime}
														value={schedule.time}
														onChange={(e) => handleChangeSchedule("time", e)}
														className="w-100"
													/>
												</div>
											</Form.Group>
											<Form.Group className="mb-3">
												<Form.Label>Notification Type</Form.Label>
												<Form.Control
													as="select"
													disabled={isNotificationPushing}
													value={notificationType}
													onChange={(e) => handleChangeNotificationType(e)}
												>
													{listNotificationType.map((type) => {
														return (
															<option value={type.value} key={type.value}>
																{type.name}
															</option>
														);
													})}
												</Form.Control>
											</Form.Group>
											{[1, 2, 3, 4].includes(notificationType) ? (
												<Form.Group className="mb-3">
													<Form.Label>
														{notificationType === 1
															? "Product ID"
															: notificationType === 2
															? "Category ID"
															: notificationType === 3
															? "SubCategory ID"
															: "Brand ID"}
														{formError !== "" && (
															<FormError>{formError.typeItemID}</FormError>
														)}
													</Form.Label>
													<Form.Control
														type="search"
														id="typeItemID"
														placeholder={
															notificationType === 1
																? "Search products (sku, name)..."
																: notificationType === 2
																? "Search categories (id, name)..."
																: notificationType === 3
																? "Search SubCategories (id, name)..."
																: "Search brands (id, name)..."
														}
														required
														disabled={isNotificationPushing}
														isInvalid={formError.typeItemID}
														value={generalTypeItemSearch}
														onChange={(e) => {
															handleSearchGeneralTypeItem(e);
															setGeneralTypeItemSearch(e.target.value);
														}}
													/>
												</Form.Group>
											) : null}
											{[1].includes(notificationType) ? (
												<Form.Group controlId="checkboxReceiveEmail">
													<Form.Check
														type="switch"
														id="checkboxTargetCustomer"
														ref={_switchCheckTargetCustomer}
														disabled={isNotificationPushing}
														label="Will only send to customers who have purchased the product."
													/>
												</Form.Group>
											) : null}
											{[1, 2, 3, 4].includes(notificationType) && isSearched ? (
												<TableBodyWidth className="table-responsive generalTypeSearchContent">
													<Table striped bordered hover>
														<tbody>{generalTypeSearchContent()}</tbody>
													</Table>
													<div className="d-flex justify-content-end">
														{generalTypePagination}
													</div>
												</TableBodyWidth>
											) : null}

											<Form.Group className="mb-3">
												<Form.Label>
													Title
													{formError.title !== "" && (
														<FormError>{formError.title}</FormError>
													)}
												</Form.Label>
												<EditorTool
													value={notificationTitle}
													setValue={handleChangeNotificationTitle}
													page="notifications"
												/>
												{/* <Editor
													apiKey={Constant.TINY_API_KEY}
													value={notificationTitle}
													onEditorChange={(newValue, editor) => {
														handleChangeNotificationTitle(newValue);
													}}
													init={{
														height: 200,
														min_height: 150,
														max_height: 300,
														menubar: false,
														plugins: ["wordcount"],
														toolbar:
															"undo redo |" +
															"styles fontsize |" +
															"bold italic underline |" +
															"removeformat",
													}}
												/> */}
												{/* <Form.Control
													type="text"
													placeholder="Notification Title"
													value={notificationTitle}
													onChange={(e) => handleChangeNotificationTitle(e)}
													required
													disabled={isNotificationPushing}
													isInvalid={formError.title}
												/> */}
											</Form.Group>
											<Form.Group className="mb-3">
												<Form.Label>
													Body
													{formError.body !== "" && <FormError>{formError.body}</FormError>}
												</Form.Label>
												{/* <Form.Control
													as="textarea"
													placeholder="Notification Content"
													value={notificationBody}
													onChange={(e) => handleChangeNotificationBody(e)}
													rows={5}
													required
													isInvalid={formError.body}
													disabled={isNotificationPushing}
												/> */}
												<EditorTool
													value={notificationBody}
													setValue={handleChangeNotificationBody}
													page="notifications"
												/>
												{/* <Editor
													apiKey={Constant.TINY_API_KEY}
													value={notificationBody}
													onEditorChange={(newValue, editor) => {
														handleChangeNotificationBody(newValue);
													}}
													init={{
														height: 300,
														min_height: 250,
														max_height: 500,
														menubar: false,
														plugins: ["lists", "wordcount"],
														toolbar:
															"undo redo |" +
															"styles fontsize |" +
															"bold italic underline |" +
															"bullist numlist |" +
															"removeformat",
													}}
												/> */}
											</Form.Group>
											<Form.Group className="mb-3">
												<Form.Label>
													Click Action URL - (optional)
													{/* {formError.actionUrl !== "" && (
												<FormError>{formError.actionUrl}</FormError>
											)} */}
												</Form.Label>
												<Form.Control
													type="text"
													placeholder="URL to redirect"
													value={notificationActionUrl}
													onChange={(e) => handleChangeNotificationActionUrl(e)}
													disabled={isNotificationPushing}
													// isInvalid={formError.actionUrl !== ""}
												/>
											</Form.Group>
											<Form.Group controlId="formImage">
												<Form.Label>
													Icon Url - (optional)
													{/* {formError.iconUrl !== "" && (
												<FormError>{formError.iconUrl}</FormError>
											)} */}
												</Form.Label>
												<Form.File
													ref={_notificationIconInputFile}
													id="custom-file-translate-scss"
													label={notificationIconUrl || "Select file"}
													// isInvalid={formError.iconUrl !== ""}
													//accept="image/png, image/gif, image/jpeg"
													lang="en"
													className="mb-2"
													custom
													disabled={isNotificationPushing || isUploadingImage}
													onChange={() => handleNotificationIconChange("home")}
												/>
											</Form.Group>
											<Form.Group>
												<ImageLoading>
													{isUploadingImage ? (
														<div style={{ minHeight: "220px", position: "relative" }}>
															<Spinner
																animation="grow"
																style={{
																	margin: "0",
																	position: "absolute",
																	top: "40%",
																	left: "40%",
																}}
															/>
														</div>
													) : !notificationIconUrl ? (
														<div
															style={{
																minHeight: "300px",
																background: "#F5F7FA",
																textAlign: "center",
															}}
														>
															<Photo
																style={{
																	position: "absolute",
																	top: "47%",
																	left: "47%",
																}}
															/>
														</div>
													) : (
														<Image
															src={notificationIconUrl}
															rounded
															style={{
																width: "100%",
																height: "auto",
															}}
														/>
													)}
												</ImageLoading>
											</Form.Group>
										</Form>
									</Modal.Body>
									<Modal.Footer>
										{isNotificationPushing && (
											<div style={{ marginRight: "auto" }}>
												<Loader
													h="32"
													color="#9cc54b"
													style={{ borderBottom: "3px solid #9cc54b" }}
												/>
											</div>
										)}
										<SendNotificationButton
											className="btn"
											onClick={handleSendNotification}
											disabled={isNotificationPushing}
										>
											Send
										</SendNotificationButton>
										<Button
											variant="secondary"
											onClick={handleCloseNotificationFormModal}
											disabled={isNotificationPushing}
										>
											Cancel
										</Button>
									</Modal.Footer>
								</Modal>

								<Toast
									className={toastBgColor}
									onClose={() => setShowToast(false)}
									show={showToast}
									delay={5000}
									autohide
									style={{
										position: "fixed",
										top: 70,
										right: 35,
										zIndex: 1041,
										width: "300px",
									}}
								>
									<Toast.Header>
										<strong className="mr-auto m-3">{toastMessage}</strong>
									</Toast.Header>
								</Toast>

								{paginationBasic}
							</Col>
						</Row>
					</CardContainer>
				</Tab>
				<Tab eventKey={`firebase-users`} title={`Firebase Users`}>
					<CardContainer>
						<Row>
							<Col xs={12} className="mb-2">
								<Row>
									<Col xs={12} md={4}>
										<Form.Control
											as="input"
											type="search"
											placeholder="Search Users"
											ref={_searchRef}
											onChange={handleSearchRegisteredFcmUsers}
										/>
									</Col>
									<Col xs={12} md={8} className="mt-2 mt-md-0">
										<div
											className="d-flex flex-wrap justify-content-end"
											style={{ gap: "1rem" }}
										>
											<TotalContent>
												<span className="prepend">Total</span>
												<p className="total-value">
													{/* 10 is the limit */}
													{10 * fcmUsersPage -
														(10 - registeredFcmUsers?.list?.length) +
														" ​/ " +
														(registeredFcmUsers?.totalItems || 0)}
												</p>
											</TotalContent>
											<div className="d-flex">{registeredFcmUsersPageButtons}</div>
										</div>
									</Col>
								</Row>
							</Col>
							<Col xs={12}>
								<TableContent
									style={{
										maxHeight: `${window.innerHeight - 250}px`,
										overflowY: "scroll",
									}}
								>
									<Table striped bordered hover>
										<thead>
											<tr>
												<th>User ID</th>
												<th>Username</th>
												<th>Identifiers</th>
												<th>IP Address</th>
												<th>FCM Token</th>
												<th>Device Infos</th>
												<th>Created At</th>
											</tr>
										</thead>
										<tbody>
											{registeredFcmUsers?.list?.length ? (
												isLoading ? (
													<tr>
														<td colSpan={7} className="text-center">
															<Spinner animation="grow" />
														</td>
													</tr>
												) : (
													registeredFcmUsers?.list?.map((user, index) => (
														<tr key={index}>
															<td>{user?.cust_id}</td>
															<td className="text-wrap">{user?.customer_detail?.name}</td>
															<td>
																<ul>
																	<li className="text-nowrap">
																		<strong>Email: </strong>{" "}
																		{user?.customer_detail?.email ?? "N/A"}
																	</li>
																	<li className="text-nowrap">
																		<strong>Phone: </strong>{" "}
																		{user?.customer_detail?.phone ?? "N/A"}
																	</li>
																</ul>
															</td>
															<td>{user.ip}</td>
															<td>
																<div style={{ width: "300px", wordBreak: "break-all" }}>
																	<ReadMore character={30}>
																		{user?.firebase_client_token}
																	</ReadMore>
																</div>
															</td>
															<td>
																<div style={{ width: "300px", wordBreak: "break-all" }}>
																	{user?.device_info}
																</div>
															</td>
															<td>{moment(user?.createdAt).format("DD/MMM/YY")}</td>
														</tr>
													))
												)
											) : (
												<tr>
													<td colSpan={7} className="text-center">
														No Data
													</td>
												</tr>
											)}
										</tbody>
									</Table>
								</TableContent>
							</Col>
						</Row>
					</CardContainer>
				</Tab>
				<Tab eventKey={`historic`} title={`Notification Historic`}>
					<CardContainer>
						<Row>
							<Col xs={12} className="mb-2">
								<Row>
									<Col sm={2} className="pr-1">
										<DateTime
											dateFormat="YYYY-MM-DD"
											timeFormat={false}
											closeOnSelect={true}
											inputProps={{ placeholder: "Start Date" }}
											ref={_startDateRef}
											value={startDate}
											isValidDate={(event) => {
												return endDate
													? moment(event).isSameOrBefore(moment(endDate))
													: true;
											}}
											onChange={(e) => handleSortNotificationDate("start", e)}
										/>
									</Col>
									<Col sm={2} className="px-1">
										<DateTime
											dateFormat="YYYY-MM-DD"
											timeFormat={false}
											closeOnSelect={true}
											inputProps={{ placeholder: "End Date" }}
											ref={_endDateRef}
											value={endDate}
											isValidDate={(event) => {
												return startDate
													? moment(event).isSameOrAfter(moment(startDate))
													: true;
											}}
											onChange={(e) => handleSortNotificationDate("end", e)}
										/>
									</Col>
									<Col sm={2} className="px-1">
										<Button
											variant="info"
											disabled={!startDate && !endDate}
											onClick={handleResetNotificationDate}
										>
											Clear
										</Button>
									</Col>
									<Col xs={12} md={6} className="mt-2 mt-md-0">
										<div className="d-flex justify-content-end align-items-center">
											{notificationPageButtons}
										</div>
									</Col>
								</Row>
							</Col>
							<Col xs={12}>
								<TableContent
									style={{
										maxHeight: `${window.innerHeight - 250}px`,
										overflowY: "scroll",
									}}
								>
									<Table striped bordered hover>
										<thead>
											<tr>
												<th>ID</th>
												<th>User ID</th>
												<th>Username</th>
												<th>Identifiers</th>
												<th>Type</th>
												<th>Content</th>
												<th>Date</th>
											</tr>
										</thead>
										<tbody>
											{allNotifications?.list?.length ? (
												isLoading ? (
													<tr>
														<td colSpan={7} className="text-center">
															<Spinner animation="grow" />
														</td>
													</tr>
												) : (
													allNotifications?.list?.map((notification, index) => (
														<tr key={index}>
															<td>{notification.notificationId ?? "N/A"}</td>
															<td>{notification.custId ?? "N/A"}</td>
															<td className="text-wrap">
																{notification?.customerDetails?.name ?? "N/A"}
															</td>
															<td>
																<ul>
																	<li className="text-nowrap">
																		<strong>Email: </strong>{" "}
																		{notification?.customerDetails?.email ?? "N/A"}
																	</li>
																	<li className="text-nowrap">
																		<strong>Phone: </strong>{" "}
																		{notification?.customerDetails?.phone ?? "N/A"}
																	</li>
																</ul>
															</td>
															<td>{notification.type ?? "N/A"}</td>
															<td>
																{notification.type.includes("order") ? (
																	<ul>
																		<li>
																			<strong>Order No:​​ </strong> #
																			{notification.data.order.number}
																		</li>
																		<li className="text-muted">
																			{notification.data.order.description}
																		</li>
																	</ul>
																) : notification.type.includes("walletUpdate") ? (
																	<ul>
																		<li>
																			<strong>Title: </strong>
																			{notification?.data?.content?.title}
																		</li>
																		<li>
																			<strong>Amount: </strong>
																			{notification?.data.content?.amount}
																		</li>
																		<li>
																			<strong>Reason: </strong>
																			{notification?.data?.content?.reason}
																		</li>
																	</ul>
																) : (
																	<ul>
																		<li style={{ display: "flex", gap: 5 }}>
																			<strong>Title:</strong>
																			<div
																				dangerouslySetInnerHTML={{
																					__html: notification.data.title,
																				}}
																			/>
																		</li>
																		<li className="text-wrap">
																			<strong>Body: </strong>
																			<ReadMore character={300}>{notification.data.body}</ReadMore>
																		</li>
																		<li className="text-wrap">
																			<strong>Click Action: </strong>
																			<a
																				target="_blank"
																				rel="noopener noreferrer"
																				href={notification.data.action}
																			>
																				{notification.data.action}
																			</a>
																		</li>
																		<li>
																			<strong>Icon: </strong>
																			<a
																				target="_blank"
																				rel="noopener noreferrer"
																				href={notification.data.icon}
																			>
																				{notification.data.icon}
																			</a>
																		</li>
																	</ul>
																)}
															</td>
															<td>{moment(notification.date).format("DD/MMM/YY")}</td>
														</tr>
													))
												)
											) : (
												<tr>
													<td colSpan={7} className="text-center">
														No Data
													</td>
												</tr>
											)}
										</tbody>
									</Table>
								</TableContent>
							</Col>
						</Row>
					</CardContainer>
				</Tab>
				<Tab eventKey={`schedule`} title={`Schedule Notifications`}>
					<CardContainer>
						{isLoading ? (
							<div>
								<LinearProgress variant="query" className="d-block w-100" />
							</div>
						) : draftNotifications?.list?.length ? (
							<DraftsWrapper>
								{draftNotifications?.list?.map((item) => {
									let data = JSON.parse(item?.data);
									return (
										<Card key={item?.id} className="w-100 d-flex flex-column">
											<CardActionArea
												className="w-100 d-flex flex-column justify-content-start align-items-start"
												style={{ flex: 1 }}
											>
												<CardMedia
													component="img"
													alt="Contemplative Reptile"
													image={data?.icon}
													title={item?.type}
													style={{ width: "100%", height: "200px", objectFit: "contain" }}
												/>
												<CardContent>
													<div
														className="mb-2"
														dangerouslySetInnerHTML={{ __html: data?.title }}
													/>
													<ReadMore character={200}>{data?.body}</ReadMore>
												</CardContent>
											</CardActionArea>
											<CardActions className="justify-content-end mt-auto border border-top">
												<MButton className="mr-auto">
													<Schedule />
													<p className="text-capitalize ml-1">
														{moment(item?.schedule).format("DD/MMM/YYYY hh:mm A")}
													</p>
												</MButton>
												<Tooltip title="Edit">
													<IconButton
														edge="end"
														aria-label="edit"
														color="primary"
														onClick={() => handleToggleEditSchedulePost(item)}
													>
														<Edit />
													</IconButton>
												</Tooltip>
												<Tooltip title="Send">
													<IconButton
														edge="end"
														aria-label="send"
														color="primary"
														onClick={() => handleToSendNotification(item?.id)}
													>
														<Send />
													</IconButton>
												</Tooltip>
												<Tooltip title="Delete">
													<IconButton
														edge="start"
														aria-label="delete"
														color="secondary"
														onClick={() => handleCancelDraftNotification(item?.id)}
													>
														<CancelScheduleSend />
													</IconButton>
												</Tooltip>
											</CardActions>
										</Card>
									);
								})}
							</DraftsWrapper>
						) : (
							<div className="w-100">
								<p className="text-center">No schedule notifications</p>
							</div>
						)}

						<Dialog
							open={openDialog}
							fullWidth
							maxWidth="md"
							scroll="body"
							onClose={() => handleToggleEditSchedulePost(null)}
						>
							<DialogTitle>Edit schedule notification</DialogTitle>
							<DialogContent dividers>
								<Paper className="p-3">
									<Form>
										<span>
												<FormControlLabel
													control={
														<Switch
															id="switchSendByEmail"
															checked={isEmailEnable}
															onChange={(e) => handleEnableEmail(e.target.checked)}
															disabled={isNotificationPushing}
															color="primary"
														/>
													}
													label="Send by email too"
												/>
											</span>
										<Form.Group style={{ display: "flex", gap: 10 }}>
											<div className="w-100">
												{formError.scheduleDate !== "" && (
													<FormError>Schedule Time{formError.scheduleDate}</FormError>
												)}
												<DateTime
													dateFormat="YYYY-MM-DD"
													timeFormat={false}
													closeOnSelect={true}
													inputProps={{
														placeholder: "Choose Date",
													}}
													ref={_scheduleDate}
													value={moment(schedule.date).format("YYYY-MM-DD")}
													isValidDate={(event) => {
														return moment(moment(event).format("YYYY-MM-DD")).isSameOrAfter(
															moment().format("YYYY-MM-DD")
														);
													}}
													onChange={(e) => handleChangeSchedule("date", e)}
													className="w-100"
												/>
											</div>
											<div className="w-100">
												{formError.scheduleTime !== "" && (
													<FormError>Schedule Time{formError.scheduleTime}</FormError>
												)}
												<DateTime
													dateFormat={false}
													timeFormat="hh:mm A"
													closeOnSelect={true}
													inputProps={{
														placeholder: "Choose Time",
													}}
													ref={_scheduleTime}
													value={moment(schedule.time, "hh:mm A").format("hh:mm A")}
													onChange={(e) => handleChangeSchedule("time", e)}
													className="w-100"
												/>
											</div>
										</Form.Group>
										<Form.Group className="mb-3">
											<Form.Label>Notification Type</Form.Label>
											<Form.Control
												as="select"
												disabled={isNotificationPushing}
												value={notificationType}
												onChange={(e) => handleChangeNotificationType(e)}
											>
												{listNotificationType.map((type) => {
													return (
														<option value={type.value} key={type.value}>
															{type.name}
														</option>
													);
												})}
											</Form.Control>
										</Form.Group>
										{[1, 2, 3, 4].includes(notificationType) ? (
											<Form.Group className="mb-3">
												<Form.Label>
													{notificationType === 1
														? "Product ID"
														: notificationType === 2
														? "Category ID"
														: notificationType === 3
														? "SubCategory ID"
														: "Brand ID"}
													{formError !== "" && <FormError>{formError.typeItemID}</FormError>}
												</Form.Label>
												<Form.Control
													type="search"
													id="typeItemID"
													placeholder={
														notificationType === 1
															? "Search products (sku, name)..."
															: notificationType === 2
															? "Search categories (id, name)..."
															: notificationType === 3
															? "Search SubCategories (id, name)..."
															: "Search brands (id, name)..."
													}
													required
													disabled={isNotificationPushing}
													isInvalid={formError.typeItemID}
													value={generalTypeItemSearch}
													onChange={(e) => {
														handleSearchGeneralTypeItem(e);
														setGeneralTypeItemSearch(e.target.value);
													}}
												/>
											</Form.Group>
										) : null}
										{[1].includes(notificationType) ? (
											<Form.Group controlId="checkboxReceiveEmail">
												<Form.Check
													type="switch"
													id="checkboxTargetCustomer"
													ref={_switchCheckTargetCustomer}
													disabled={isNotificationPushing}
													label="Will only send to customers who have purchased the product."
												/>
											</Form.Group>
										) : null}
										{[1, 2, 3, 4].includes(notificationType) && isSearched ? (
											<TableBodyWidth className="table-responsive generalTypeSearchContent">
												<Table striped bordered hover>
													<tbody>{generalTypeSearchContent()}</tbody>
												</Table>
												<div className="d-flex justify-content-end">
													{generalTypePagination}
												</div>
											</TableBodyWidth>
										) : null}

										<Form.Group className="mb-3">
											<Form.Label>
												Title
												{formError.title !== "" && <FormError>{formError.title}</FormError>}
											</Form.Label>
											<EditorTool
												value={notificationTitle}
												setValue={handleChangeNotificationTitle}
												page="notifications"
											/>
											{/* <Editor
												apiKey={Constant.TINY_API_KEY}
												value={notificationTitle}
												onEditorChange={(newValue, editor) => {
													handleChangeNotificationTitle(newValue);
												}}
												init={{
													height: 200,
													min_height: 150,
													max_height: 300,
													menubar: false,
													plugins: ["wordcount"],
													toolbar:
														"undo redo |" +
														"styles fontsize |" +
														"bold italic underline |" +
														"removeformat",
												}}
											/> */}
										</Form.Group>
										<Form.Group className="mb-3">
											<Form.Label>
												Body
												{formError.body !== "" && <FormError>{formError.body}</FormError>}
											</Form.Label>
											<EditorTool
												value={notificationBody}
												setValue={handleChangeNotificationBody}
												page="notifications"
											/>
											{/* <Editor
												apiKey={Constant.TINY_API_KEY}
												value={notificationBody}
												onEditorChange={(newValue, editor) => {
													handleChangeNotificationBody(newValue);
												}}
												init={{
													height: 300,
													min_height: 250,
													max_height: 500,
													menubar: false,
													plugins: ["lists", "wordcount"],
													toolbar:
														"undo redo |" +
														"styles fontsize |" +
														"bold italic underline |" +
														"bullist numlist |" +
														"removeformat",
												}}
											/> */}
										</Form.Group>
										<Form.Group className="mb-3">
											<Form.Label>Click Action URL - (optional)</Form.Label>
											<Form.Control
												type="text"
												placeholder="URL to redirect"
												value={notificationActionUrl}
												onChange={(e) => handleChangeNotificationActionUrl(e)}
												disabled={isNotificationPushing}
											/>
										</Form.Group>
										<Form.Group controlId="formImage">
											<Form.Label>Icon Url - (optional)</Form.Label>
											<Form.File
												ref={_notificationIconInputFile}
												id="custom-file-translate-scss"
												label={notificationIconUrl || "Select file"}
												//accept="image/png, image/gif, image/jpeg"
												lang="en"
												className="mb-2"
												custom
												disabled={isNotificationPushing || isUploadingImage}
												onChange={() => handleNotificationIconChange("home")}
											/>
										</Form.Group>
										<Form.Group>
											<ImageLoading>
												{isUploadingImage ? (
													<div style={{ minHeight: "220px", position: "relative" }}>
														<Spinner
															animation="grow"
															style={{
																margin: "0",
																position: "absolute",
																top: "40%",
																left: "40%",
															}}
														/>
													</div>
												) : !notificationIconUrl ? (
													<div
														style={{
															minHeight: "300px",
															background: "#F5F7FA",
															textAlign: "center",
														}}
													>
														<Photo
															style={{
																position: "absolute",
																top: "47%",
																left: "47%",
															}}
														/>
													</div>
												) : (
													<Image
														src={notificationIconUrl}
														rounded
														style={{
															width: "100%",
															height: "auto",
														}}
													/>
												)}
											</ImageLoading>
										</Form.Group>
									</Form>
								</Paper>
							</DialogContent>
							<DialogActions>
								<MButton
									variant="text"
									color="default"
									disabled={isNotificationPushing}
									onClick={() => handleToggleEditSchedulePost(null)}
								>
									Close
								</MButton>
								<MButton
									variant="outlined"
									color="primary"
									disabled={isNotificationPushing}
									onClick={handleUpdateScheduleNotification}
								>
									Update
								</MButton>
							</DialogActions>
						</Dialog>
					</CardContainer>
				</Tab>
			</Tabs>
		</HelpPageWrapper>
	);
};

// style
const HelpPageWrapper = styled.div`
	background-color: #f7f7f7;
	position: relative;
	padding: 30px;
	min-height: 50vh;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	table th {
		width: 0.8em;
	}
	table th.sortable {
		cursor: pointer;
	}

	@media (max-width: 989px) {
		padding-top: 70px;
	}
	& > div.row {
		background-color: #fff;
		padding: 30px 20px;
		border-radius: 10px;
		box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	}

	.nav-tabs .nav-link {
		color: #b2b2b2;

		&.active {
			color: #495057;
			font-weight: 500 !important;
		}
	}
`;
const CardContainer = styled.div`
	background-color: #fff;
	padding: 20px 20px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
`;

const TableBodyWidth = styled.div`
	table tr th {
		white-space: nowrap;
		width: initial;
		vertical-align: middle;
	}
`;

const TableContent = styled.div`
	table {
		tr th {
			white-space: nowrap;
			width: initial;
			scrollbar-width: none;
		}

		thead tr th {
			white-space: nowrap;
			width: initial;
			vertical-align: middle;
			padding: 10px !important;
		}

		tbody tr td {
			padding: 10px !important;
		}
	}

	padding-right: 6px;

	::-webkit-scrollbar {
		width: 9px;
		height: 9px;
		border-radius: 9px;
	}

	::-webkit-scrollbar-thumb {
		background: #dee2e6;
		border-radius: 9px;

		&:hover {
			background: #83898e;
		}
	}
`;

const DraftsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
	gap: 1rem;
	// place-items: end;
`;

const TotalContent = styled.div`
	display: flex;
	align-items: center;
	border: 1px solid #ced4da;
	border-radius: 0.25rem;
	overflow: hidden;
	white-space: nowrap;
	text-align: center;
	line-height: 1.5;
	color: #495057;

	.prepend {
		background: #e9ecef;
		padding: 0.375rem 0.75rem;
		border-right: 1px solid #ced4da;
	}

	.total-value {
		padding: 0.375rem 0.75rem;
	}
`;

const NotificationInput = styled.div`
	width: 600px;
	padding: 10px;
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
	margin-bottom: 20px;
	border-radius: 5px;
`;
const SendNotificationButton = styled.button`
	// float: right;
	// padding: 5px 20px;
	// background-color: #9cc54b;
	// color: #fff;
	// border: 1px solid #9cc54b;
	// border-radius: 3px;
	// box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
	color: #fff;
	background-color: #9cc54b;
	border-color: #9cc54b;
	&:hover {
		background-color: #9cc54be8;
		border-color: #9cc54be8;
		color: #fff;
	}
`;
const NotificationFormModalTrigger = styled.button`
	float: right;
	padding: 5px 20px;
	font-weight: 600;
	background-color: #9cc54b;
	color: #fff;
	border: 1px solid #9cc54b;
	border-radius: 3px;
	box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
		rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
	&:hover {
		background-color: #9cc54be8;
		border-color: #9cc54be8;
		color: #fff;
	}
`;
const FormError = styled.span`
	font-size: 13px;
	color: red;
`;

const labelStyle = {
	lineHeight: "2.5rem",
};
const ImageLoading = styled.div`
	position: relative;

	.hide {
		display: none;
	}
	.isLoading {
		position: absolute;
		background-color: rgb(255, 255, 255, 0.4);
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
`;

const mapStateToProps = (state) => {
	return {};
};

const mapDispatchToProps = (dispatch) => {
	return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationCenter);
